const ResolutionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      {...props}
    >
      <path
        d="M29.9086 43.0555V37.807H16.3154V33.6725C17.0706 32.4895 17.8258 31.3001 18.581 30.1042C19.3361 28.9086 20.0913 27.716 20.8465 26.5266C21.6016 25.3372 22.3536 24.1478 23.1025 22.9583C23.8513 21.7689 24.6035 20.5795 25.3587 19.3901C26.1139 18.2007 26.869 17.0084 27.6242 15.8125H34.5529V33.8423H38.2345V37.807H34.5529V43.0555H29.9086ZM20.6954 33.9367H29.9841V19.4939H29.8709C29.254 20.4506 28.6404 21.4041 28.0301 22.3542C27.4195 23.3047 26.8092 24.2581 26.1988 25.2144C25.5882 26.1711 24.9746 27.1277 24.3581 28.0841C23.7412 29.0408 23.1277 29.9941 22.5173 30.9443C21.9067 31.8948 21.2996 32.8482 20.6954 33.8046V33.9367Z"
        fill="#027C80"
      />
      <path
        d="M41.7461 43.0555V15.8125H46.6171V43.0555H41.7461ZM46.3527 34.5787V28.6127H46.7303L57.3028 15.8125H62.8722L52.564 28.1218H51.8089L46.3527 34.5787ZM57.7748 43.0555L48.6182 30.1231L52.1109 26.8758L63.684 43.0555H57.7748Z"
        fill="#027C80"
      />
      <path
        d="M20.3447 67.3886C19.7556 67.3886 19.2498 67.2783 18.8271 67.0579C18.4042 66.8375 18.0793 66.5306 17.8523 66.1374C17.6253 65.7443 17.5117 65.2894 17.5117 64.7728V60.1484H18.4001V64.7136C18.4001 65.0788 18.4766 65.4005 18.6296 65.6784C18.7827 65.9565 19.0039 66.1744 19.2934 66.3324C19.5829 66.4903 19.9333 66.5693 20.3447 66.5693C20.7559 66.5693 21.1055 66.4903 21.3934 66.3324C21.6812 66.1744 21.9009 65.9565 22.0523 65.6784C22.2036 65.4005 22.2793 65.0788 22.2793 64.7136V60.1484H23.1677V64.7728C23.1677 65.2894 23.0549 65.7443 22.8296 66.1374C22.6042 66.5306 22.2809 66.8375 21.8599 67.0579C21.4386 67.2783 20.9336 67.3886 20.3447 67.3886Z"
        fill="#FFA473"
      />
      <path
        d="M24.5498 67.2701V60.1484H25.4382V66.4706H28.8733V67.2701H24.5498Z"
        fill="#FFA473"
      />
      <path
        d="M30.5659 67.2701V60.9479H28.3203V60.1484H33.6998V60.9479H31.4543V67.2701H30.5659Z"
        fill="#FFA473"
      />
      <path
        d="M34.6377 67.2701V60.1484H37.3078C37.765 60.1484 38.1639 60.2365 38.5046 60.4125C38.8451 60.5885 39.1091 60.8353 39.2967 61.1527C39.4841 61.4703 39.578 61.843 39.578 62.2706V62.2804C39.578 62.774 39.4504 63.2009 39.1954 63.5612C38.9405 63.9215 38.5909 64.1724 38.1467 64.3138L39.7951 67.2701H38.7538L37.2287 64.452H35.5261V67.2701H34.6377ZM35.5261 63.6673H37.2287C37.686 63.6673 38.0389 63.5489 38.2873 63.312C38.5358 63.0751 38.66 62.7378 38.66 62.3002V62.2904C38.66 61.8659 38.5292 61.5345 38.2676 61.2959C38.006 61.0574 37.6466 60.9381 37.1892 60.9381H35.5261V63.6673Z"
        fill="#FFA473"
      />
      <path
        d="M40.126 67.2701L42.7763 60.1484H43.4328V61.2144H43.2057L41.0589 67.2701H40.126ZM41.3402 65.2318L41.6363 64.4767H44.7948L45.0909 65.2318H41.3402ZM45.3674 67.2701L43.2254 61.2144V60.1484H43.6548L46.3 67.2701H45.3674Z"
        fill="#FFA473"
      />
      <path
        d="M48.9902 67.2701V60.1484H50.8016V62.9467H53.6394V60.1484H55.4506V67.2701H53.6394V64.4027H50.8016V67.2701H48.9902Z"
        fill="#FFA473"
      />
      <path
        d="M56.5264 67.2701V60.1484H59.4234C60.1374 60.1484 60.7493 60.2833 61.2594 60.5531C61.7693 60.8229 62.1592 61.2186 62.4291 61.74C62.6988 62.2616 62.8338 62.9007 62.8338 63.6574V63.6673C62.8338 64.4241 62.6988 65.0714 62.4291 65.6093C62.1592 66.1473 61.7702 66.5587 61.2618 66.8432C60.7536 67.1278 60.1407 67.2701 59.4234 67.2701H56.5264ZM58.3377 65.8092H59.1816C59.5731 65.8092 59.9038 65.7295 60.1736 65.5699C60.4434 65.4103 60.6465 65.1726 60.7831 64.8567C60.9197 64.5408 60.9879 64.146 60.9879 63.6722V63.6623C60.9879 63.2182 60.9171 62.8431 60.7757 62.5371C60.6343 62.2311 60.4278 62 60.1563 61.8437C59.8848 61.6875 59.5599 61.6093 59.1816 61.6093H58.3377V65.8092Z"
        fill="#FFA473"
      />
      <path
        d="M1.11328 53.2969H78.8874V65.3942C78.8874 70.2797 74.921 74.2461 70.0355 74.2461H9.96524C5.07971 74.2461 1.11328 70.2797 1.11328 65.3942V53.2969Z"
        stroke="#06AEB3"
        strokeWidth="2.22586"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.8871 54.4452H1.11293C0.498287 54.4452 0 53.9469 0 53.3322V15.9649C0 10.4703 4.47026 6 9.9649 6H70.0352C75.5297 6 80 10.4703 80 15.9649V53.3322C80 53.9469 79.5017 54.4452 78.8871 54.4452ZM2.22586 52.2193H77.7741V15.9649C77.7741 11.6976 74.3025 8.22586 70.0352 8.22586H9.9649C5.69756 8.22586 2.22586 11.6976 2.22586 15.9649V52.2193Z"
        fill="#027C80"
      />
    </svg>
  );
};

export default ResolutionIcon;
